/**
 * React, react redux and react localization imports
 */
import { useDispatch, useSelector } from 'react-redux'

/**
 * Material imports
 */
import {
  Box,
  Button
} from '@mui/material'

/**
 * Relative exports to root directory
 */
import { useTranslation } from 'react-i18next'
import { selectLanguage } from '../../../state/lang'
import { pallete } from '../../../theme'
import { isDefined } from '../../../utils'
import { TranslatableTypography } from './Typography'

const style = {
  container: {
    color: pallete.paperColor,
    padding: '0px'
  },
  button: {
    color: pallete.paperColor,
    textAlign: 'center',
    padding: '0px',
    margin: '0px',
    height: '40px',
    minWidth: '0px',
    marginRight: '10px  '
  },
  text: {
    color: pallete.paperColor,
    textShadow: `1px 1px 3px ${pallete.textColor}`,
    fontWeight: 800
  }
}

export const LanguageSelectText = () => {
  const { language, refresh, supportedLanguages } = useSelector(state => state?.language)
  const dispatch = useDispatch()
  const translation = useTranslation()
  const { t, i18n } = translation

  if (isDefined(language) && language !== i18n.language && !refresh) {
    i18n.changeLanguage(language)
  }

  const changeLanguage = () => {
    const select = t('toggle_next_language')
    i18n.changeLanguage(select)
    dispatch(selectLanguage(select))
  }

  const visibility = supportedLanguages.length > 1 ? 'visible' : 'hidden'

  return (
    <Box
      data-component="language-select"
      data-active-language={language}
      sx={{ visibility, ...style.container }}
    >
      <Button
        sx={style.button}
        onClick={changeLanguage}
      >
        <TranslatableTypography sx={style.text}>
          toggle_next_language_label
        </TranslatableTypography>
      </Button>
    </Box>
  )
}
